import React, { useState, useEffect } from "react";

import logoWhite from '../assets/images/logo-brios.webp';
import logoBrown from '../assets/images/logo-brios-cafe.webp';
import iconPedido from '../assets/images/icon-pedido.webp';

const Navbar = () => {
  const [scrollDir, setScrollDir] = useState("scrolling down");

  useEffect(() => {
    const threshold = 0;
    let lastScrollY = window.pageYOffset;
    let ticking = false;
    //console.log("scrollY", window.scrollY)
    var x = window.matchMedia("(max-width: 1000px)");
    //collapseShow(x)// Call listener function at run time
    //x.addListener(collapseShow); // Attach listener function on state changes

    window.onscroll = classScroll();

    const updateScrollDir = () => {
      const scrollY = window.pageYOffset;

      if (Math.abs(scrollY - lastScrollY) < threshold) {
        ticking = false;
        return;
      }
      setScrollDir(scrollY > lastScrollY ? "scrolling down" : "scrolling up");
      lastScrollY = scrollY > 0 ? scrollY : 0;
      ticking = false;
    };

    const onScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(updateScrollDir);
        ticking = true;
      }
    };

    window.addEventListener("scroll", onScroll);

    //console.log(lastScrollY, scrollDir);

    if(lastScrollY <= 150){
      //console.log('works');
    }

    return () => window.removeEventListener("scroll", onScroll);
  }, [scrollDir]);

  const classScroll = (ev) => {
    var element = document.getElementById('navbar');
    var lw = document.getElementById('logoW');
    var lb = document.getElementById('logoB');
    let btn1 = document.getElementById('btn_D');
    let btn2 = document.getElementById('btn2_D');
    if (window.scrollY) {
      /*element && element.classList.add("bwhite");*/
      element && element.classList.add("fixed-top");
      /*lw && lw.classList.add("d-none");
      lb && lb.classList.remove("d-none");
      btn1 && btn1.classList.add('d-none');
      btn2 && btn2.classList.remove('d-none');
      btn2 && btn2.classList.add('d-block');*/
    } else {
      /*element && element.classList.remove("bwhite");*/
      element && element.classList.remove("fixed-top");
      /*lw && lw.classList.remove("d-none");
      lb && lb.classList.add("d-none");
      btn1.classList.remove('d-none');
      btn2.classList.remove('d-block');
      btn2.classList.add('d-none');*/
    }
  }

  const collapseShow = (x) => {
    let element = document.getElementById('navbarToggleExternalContent');
    //console.log(x.matches);
    if (x.matches) {
      classScroll(true);
      element.classList.add('collapse');
      element.classList.remove('d-flex');
      element.classList.remove('justify-content-around');
      element.classList.remove('col-lg-12');

    } else {
      classScroll(false);
      element.classList.remove("collapse");
      element.classList.add('d-flex');
      element.classList.add('justify-content-around');
      element.classList.add('col-lg-12');
    }
  }

  return (
    <div id="navbar" className="pt-4 w-100 bwhite">
            <div className="navbar container">
              <nav className="nav nav-pills flex-column flex-sm-row">
                <div className="col-sm col-md-12 col-lg-3">
                  {/*<button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarToggleExternalContent" aria-controls="navbarToggleExternalContent" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                  </button>*/}
                  <div className="logo flex-sm-fill text-sm-center nav-link">
                    <a href="#home"><img id="logoW" className="d-none" src={logoWhite} alt="Brios Logo" /></a>
                    <a href="#home"><img id="logoB" src={logoBrown} alt="Brios Logo" /></a>
                  </div>
                </div>
                {/*<div className="col-sm-12 col-lg-9">
                  <p id="btn_D" className="twhite ad-btn text-lg-end d-none"><img src={iconPedido} alt="Distribuidores" /> 
                  <strong><a href="#distribuidores" className="font2">ENCUENTRA EL PUNTO DE VENTA MÁS CERCANO AQUÍ</a></strong></p>
                  <div id="navbarToggleExternalContent" className="col-sm-12">
                    <a className="flex-sm-fill text-sm-center nav-link" href="#home">Home</a>
                    <a className="flex-sm-fill text-sm-center nav-link" href="#grupo-brios">Grupo Brios</a>
                    <a className="flex-sm-fill text-sm-center nav-link" href="#productos">Productos</a>
                    <a className="flex-sm-fill text-sm-center nav-link" href="#blog">Blog</a>
                    <a className="flex-sm-fill text-sm-center nav-link" href="#contacto">Contacto</a>
                    <a id="btn2_D" className="flex-sm-fill text-sm-center nav-link" href="#distribuidores"><img src={iconPedido} alt="Distribuidores" /></a>
                  </div>
                </div>*/}
              </nav>
            </div>
          </div>
  );
};

export default Navbar;